import React from 'react';
import { AuthImage } from '@/components/AuthImage';

/**
 * Read-only display of saved custom field values.
 * Props:
 *  - defs: custom_fields definitions (for labels/types); optional
 *  - values: { [key]: value } stored on the garment/sale
 */
export function CustomFieldsView({ defs = [], values = {}, idPrefix = 'cfv' }) {
  const entries = Object.entries(values || {}).filter(([, v]) => {
    if (v === null || v === undefined || v === '') return false;
    if (Array.isArray(v)) return v.length > 0;
    return true;
  });
  if (!entries.length) return null;
  const byKey = Object.fromEntries((defs || []).map((f) => [f.key, f]));

  const label = (key) => (byKey[key]?.name) || key;
  const typeOf = (key, v) => byKey[key]?.type || ((Array.isArray(v) || (v && typeof v === 'object' && v.path)) ? 'photo' : 'text');

  return (
    <div className="grid grid-cols-2 gap-x-3 gap-y-2 text-sm" data-testid={`${idPrefix}-view`}>
      {entries.map(([key, v]) => {
        const t = typeOf(key, v);
        const photos = t === 'photo' ? (Array.isArray(v) ? v : (v && v.path ? [v] : [])) : [];
        return (
          <div key={key} data-testid={`${idPrefix}-${key}`}>
            <p className="text-xs text-muted-foreground">{label(key)}</p>
            {t === 'photo' ? (
              <div className="mt-1 flex flex-wrap gap-1.5">
                {photos.map((p, idx) => (
                  <AuthImage key={p.path || idx} path={p.path} alt={label(key)} className="h-20 w-20 rounded-lg object-cover ring-1 ring-border" />
                ))}
              </div>
            ) : t === 'boolean' ? (
              <p className="font-medium">{v === true ? 'Yes' : 'No'}</p>
            ) : (
              <p className="font-medium break-words">{String(v)}</p>
            )}
          </div>
        );
      })}
    </div>
  );
}
